













import { Vue, Component, Prop } from 'vue-property-decorator';
import {namespace} from "vuex-class";

import {errorHandler} from '@/services/services';
import OpenHub from '@/views/components/openHub/OpenHub.vue';
import {IActiveShipment} from "@/models/StoreModels";
import {OPEN_HUB_MODES} from "@/constants/openHub";

const activeShipmentsModule = namespace('activeShipments');


@Component({
  name: 'OpenHubSharedLogic',
  components: {
    OpenHub,
  },
})
export default class OpenHubSharedLogic extends Vue {
  @Prop()
  private asId!: string;

  @Prop({default: OPEN_HUB_MODES.PICK_UP})
  private openHubMode!: string;

  @activeShipmentsModule.Action('depositShipment')
  private depositShipment!: (asId: number|string) => Promise<any>;

  @activeShipmentsModule.Action('pickupShipment')
  private pickupShipment!: (asId: string|number) => Promise<any>;

  @activeShipmentsModule.Action('reOpenShipment')
  private reOpenShipment!: (asId: string|number) => Promise<any>;

  @activeShipmentsModule.Action('init')
  private updateShipments!: () => Promise<any>;

  @activeShipmentsModule.Getter('getActiveOrderById')
  private getActiveOrderById!: (asId: number|string) => IActiveShipment;

  private loading: boolean = false;
  private depositError: boolean = false;
  private finishOpen: boolean = false;

  private get isPickUp(): boolean {
    return OPEN_HUB_MODES.PICK_UP === this.openHubMode;
  }

  private get isDeposit(): boolean {
    return OPEN_HUB_MODES.DEPOSIT === this.openHubMode;
  }

  private get getHubId(): number|null {
    return this.isDeposit ? this.getHubIdDeposit :
           this.isPickUp ? this.getHubIdPickUp :
           null;
  }

  private get getHubIdDeposit(): number|null {
    const myShipping = this.getActiveOrderById(this.asId);
    return myShipping ? myShipping.from_hub_id : null;
  }

  private get getHubIdPickUp(): number|null {
    const myShipping = this.getActiveOrderById(this.asId);
    return myShipping ? myShipping.to_hub_id : null;
  }

  private resetOpen() {
    this.loading = false;
    this.depositError = false;
    this.finishOpen = false;
  }

  private reOpenHub() {
    this.startOpeningHub();
    this.reOpenShipment(this.asId)
        .catch(this.showErrors)
        .finally(this.finishOpeningHub);
  }

  private openHub() {
    this.startOpeningHub();

    this.openHubSpecific()
        .then(this.updateShipments)
        .catch(this.showErrors)
        .finally(this.finishOpeningHub);
  }

  private openHubSpecific(): Promise<any> {
    return this.isDeposit ? this.depositShipment(this.asId) :
                            this.pickupShipment(this.asId);
  }


  private startOpeningHub() {
    this.loading = true;
    this.finishOpen = false;
  }

  private finishOpeningHub() {
    this.loading = false;
    this.finishOpen = true;
  }

  private showErrors(err: any) {
    this.depositError = true;
    errorHandler.handleErrorsResponse(err, this.isDeposit ? 'depositItem.errors' : 'pickupItem.errors');
  }
}
